bcn.fauxLinks = (function () {

  'use strict';

  var elSelector = '[data-trigger-hover]',
    hoverClass = 'hover';

  function triggerHover () {
    var el = $(elSelector);

    el.on('mouseenter', function () {
      $(this).addClass(hoverClass);
    }).on('mouseleave', function () {
      $(this).removeClass(hoverClass);
    });

  }

  return {
    init: function () {
      triggerHover();
    }
  };

})();
